export default (theme) => ({
  panelHeader: {
    marginTop: 15,
    fontSize: 12,
    fontWeight: 600,
    marginBottom: "1rem",
  },
  checkBoxStyle: {
    //marginLeft: "5px",
    marginRight: 0,
  },
  header: {
    fontSize: "16px",
    backgroundColor: "#F3F3F3",
    color: "black",
    padding: 10,
    marginBottom: 3,
    width: "100%",
  },
  errorText: {
    fontSize: 12,
    color: "#e30613",
  },
});
